import { render, staticRenderFns } from "./errorsum.vue?vue&type=template&id=bf0a5bfe&scoped=true&"
import script from "./errorsum.vue?vue&type=script&lang=js&"
export * from "./errorsum.vue?vue&type=script&lang=js&"
import style0 from "./errorsum.vue?vue&type=style&index=0&id=bf0a5bfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0a5bfe",
  null
  
)

export default component.exports